<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    class="btn btn-success btn-fill"
                    @click="salvarCliente"
                  >
                    Salvar
                  </button>
                </div>
              </div>
              <div style="margin: 3%">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Cliente</h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <base-radio
                          v-model="cliente.tipoParceiro"
                          label="pf"
                          name="tipoPessoa"
                          @change="checkedRadio"
                          @input="checkedRadio"
                          >Pessoa Física</base-radio
                        >
                      </div>
                      <div class="col-md-6">
                        <base-radio
                          v-model="cliente.tipoParceiro"
                          label="pj"
                          name="tipoPessoa"
                          @change="checkedRadio"
                          @input="checkedRadio"
                          >Pessoa Jurídica</base-radio
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input
                          v-if="checkedRadio()"
                          label="Nome"
                          placeholder="Nome"
                          v-model="cliente.nome"
                        ></base-input>
                        <base-input
                          v-if="!checkedRadio()"
                          label="Razão Social"
                          placeholder="Razão Social"
                          v-model="cliente.razaoSocial"
                        ></base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input
                          v-if="!checkedRadio()"
                          label="Pessoa para Contato"
                          placeholder="Pessoa para Contato"
                          v-model="cliente.pessoaContato"
                        ></base-input>
                        <base-input
                          v-if="checkedRadio()"
                          label="Sobrenome"
                          placeholder="Sobrenome"
                          v-model="cliente.sobrenome"
                        ></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <base-input
                          type="email"
                          label="e-mail"
                          placeholder="e-mail"
                          v-model="cliente.email"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          label="CPF"
                          placeholder="CPF"
                          v-model="cliente.cpfOrCnpj"
                          v-if="checkedRadio()"
                          maxlength="11"
                        ></base-input>

                        <base-input
                          type="text"
                          label="CNPJ"
                          placeholder="CNPJ"
                          v-model="cliente.cpfOrCnpj"
                          v-if="!checkedRadio()"
                          maxlength="14"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          type="text"
                          label="Telefone"
                          placeholder="Telefone"
                          v-model="cliente.telefone"
                          maxlength="11"
                        ></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <base-input
                          label="bairro"
                          placeholder="Bairro"
                          v-model="cliente.bairro"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          label="Rua"
                          placeholder="Rua"
                          v-model="cliente.rua"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          label="número"
                          placeholder="Número"
                          v-model="cliente.numero"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div v-if="!isPropostaReady" class="col-12">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Usina</h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input
                          type="number"
                          label="KWP"
                          placeholder="KWP"
                          v-model="cliente.qtdKwp"
                        ></base-input>
                      </div>
                      <div class="col-md-6">
                        <label for="tecnologia">Tecnologia</label>
                        <select
                          v-model="cliente.tipoTecnologia"
                          class="form-control"
                        >
                          <option
                            v-for="option in tecnologiaOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Módulo</h4>
                      </div>
                    </div>
                    <div
                      v-for="(modulo, index) in cliente.modulos"
                      :key="modulo"
                      class="row"
                    >
                      <div class="col-md-3">
                        <base-input
                          label="Potência"
                          placeholder="Potência"
                          v-model="modulo.potencia"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          label="Fabricante"
                          placeholder="Fabricante"
                          v-model="modulo.fabricante"
                        ></base-input>
                      </div>
                      <div class="col-md-2">
                        <base-input
                          type="number"
                          label="Quantidade"
                          placeholder="Quantidade"
                          v-model="modulo.quantidade"
                        ></base-input>
                      </div>
                      <div class=" mr-2 mt-4">
                        <button
                          class="btn btn-icon btn-success btn-fill"
                          @click="addModulo()"
                        >
                          <i class="fa fa-plus-circle"></i>
                        </button>
                      </div>
                      <div class=" mt-4">
                        <button
                          class="btn btn-icon btn-danger btn-fill"
                          @click="removeModulo(index)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Inversor</h4>
                      </div>
                    </div>
                    <div
                      v-for="(inversor, index) in cliente.inversores"
                      :key="inversor"
                      class="row"
                    >
                      <div class="col-md-3">
                        <base-input
                          label="Potência"
                          placeholder="Potência"
                          v-model="inversor.potencia"
                        ></base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          label="Fabricante"
                          placeholder="Fabricante"
                          v-model="inversor.fabricante"
                        ></base-input>
                      </div>
                      <div class="col-md-2">
                        <base-input
                          type="number"
                          label="Quantidade"
                          placeholder="Quantidade"
                          v-model="inversor.quantidade"
                        ></base-input>
                      </div>
                      <div class="mr-2 mt-4">
                        <button
                          class="btn btn-icon btn-success btn-fill"
                          @click="addInversor()"
                        >
                          <i class="fa fa-plus-circle"></i>
                        </button>
                      </div>
                      <div class="mt-4">
                        <button
                          class="btn btn-icon btn-danger btn-fill"
                          @click="removeInversor(index)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="codigo" class="row">
                <div class="col-12">
                  <vue-tabs
                    textPosition="center"
                    :centered="true"
                    class="crm-tabs"
                  >
                    <v-tab v-if="isPropostaReady" title="Usina">
                      <div class="row">
                        <div class="col-12">
                          <proposta-form :proposta="proposta"></proposta-form>
                        </div>
                      </div>
                    </v-tab>
                    <v-tab title="Boletim">
                      <div class="row">
                        <div class="col-12">
                          <div class="overflow-auto">
                            <l-table
                              class="table-hover table-striped"
                              :columns="tabelaBoletim.columns"
                              :data="tabelaBoletim.data"
                            >
                              <template slot-scope="{ row }">
                                <td>
                                  <b>{{ row.data }}</b>
                                </td>
                                <td>
                                  {{ row.descricao }}
                                </td>
                                <td>
                                  {{ row.obs }}
                                </td>
                              </template>
                            </l-table>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>Descrição</label>
                                <textarea
                                  class="form-control border-input"
                                  rows="4"
                                  label="Descricao"
                                  placeholder="Descricao"
                                  v-model="boletim.descricao"
                                ></textarea>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <base-input
                                type="text"
                                label="Observação"
                                placeholder="Observação"
                                v-model="boletim.obs"
                              ></base-input>
                            </div>
                            <div class="col-md-2 mt-4">
                              <button
                                class="btn btn-icon btn-info btn-fill"
                                @click.prevent="uploadPdf()"
                              >
                                Anexar PDF
                              </button>
                            </div>
                            <div class="col-md-1 mt-4">
                              <button
                                class="btn btn-icon btn-success btn-fill"
                                @click="addBoletim()"
                              >
                                <i class="fa fa-plus-circle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab>
                    <v-tab title="Relatório de Geração">
                      <div class="row">
                        <div class="col-12" v-if="!geracoes.dias">
                          <p class="text-center mt-2">
                            Não há registros de geração diários
                          </p>
                        </div>
                        <div class="col-12" v-show="geracoes.dias">
                          <vue-tabs
                            textPosition="center"
                            :centered="true"
                            class="crm-tabs mb-3 mt-4"
                          >
                            <v-tab title="Dias">
                              <p class="text-center mt-2">
                                Energia diária no mês atual
                              </p>
                              <bar-chart
                                :options="opcoesGraficoGeracoes"
                                v-show="geracoes && geracoes.dias"
                                :chart-data="geracoes.dias"
                                :style="graficoGeracoesStyles"
                              ></bar-chart>
                            </v-tab>
                            <v-tab title="Meses">
                              <p class="text-center mt-2">
                                Energia mensal no ano atual
                              </p>
                              <bar-chart
                                :options="opcoesGraficoGeracoes"
                                :chart-data="geracoes.meses"
                                v-show="geracoes && geracoes.meses"
                                :style="graficoGeracoesStyles"
                              ></bar-chart>
                            </v-tab>
                            <v-tab title="Anos">
                              <p class="text-center mt-2">
                                Energia anual na vida
                              </p>
                              <bar-chart
                                :options="opcoesGraficoGeracoes"
                                :chart-data="geracoes.anos"
                                v-show="geracoes && geracoes.anos"
                                :style="graficoGeracoesStyles"
                              ></bar-chart>
                            </v-tab>
                          </vue-tabs>
                        </div>
                        <div class="col-12" v-if="geracoes.dias">
                          <button
                            class="btn btn-icon btn-info btn-fill mb-3"
                            @click.prevent="enviarRelatorioGeracaoMensal()"
                          >
                            Enviar Relátorio de Geração Mensal
                          </button>
                        </div>
                        <div class="col-12 garantias">
                          <div class="row mb-2">
                            <div class="col-md-3">
                              <label class="mr-2">Inicio da Garantia</label>
                              <date-picker
                                format="DD/MM/YYYY"
                                v-model="cliente.inicioGarantia"
                                type="date"
                                default-value="null"
                              ></date-picker>
                            </div>
                            <div class="col-md-3">
                              <label class="mr-2">Fim da Garantia</label>
                              <date-picker
                                format="DD/MM/YYYY"
                                v-model="cliente.fimGarantia"
                                type="date"
                              ></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab>
                    <v-tab title="Lembretes">
                      <div class="row">
                        <div class="col-12">
                          <div class="overflow-auto">
                            <l-table
                              class="table-hover table-striped"
                              :columns="tabelaLembretes.columns"
                              :data="tabelaLembretes.data"
                            >
                              <template slot-scope="{ row, rowIndex }">
                                <td>
                                  <b>{{
                                    formatarDataPadraoBrByDate(
                                      new Date(row.data)
                                    )
                                  }}</b>
                                </td>
                                <td>
                                  {{ row.descricao }}
                                </td>
                                <button
                                  class="btn btn-icon btn-danger"
                                  @click="deletarLembrete(rowIndex)"
                                >
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </template>
                            </l-table>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <label>Data</label>
                              <br />
                              <date-picker
                                format="DD/MM/YYYY"
                                v-model="lembrete.data"
                                type="date"
                              ></date-picker>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>Descrição</label>
                                <textarea
                                  class="form-control border-input"
                                  rows="5"
                                  label="Descricao"
                                  placeholder="Descricao"
                                  v-model="lembrete.descricao"
                                ></textarea>
                              </div>
                            </div>
                            <div class="col-md-1 mt-4">
                              <button
                                class="btn btn-icon btn-success btn-fill"
                                @click="addLembrete()"
                              >
                                <i class="fa fa-plus-circle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab>
                  </vue-tabs>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LTable from 'src/components/Table.vue';
import PropostaForm from '../Forms/PropostaForm.vue';
import { VueTabs, VTab } from 'vue-nav-tabs';
import ClientesService from 'src/services/clientes';
import formatDateFns from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';
import vPagination from 'vue-plain-pagination';
import VTooltip from 'v-tooltip';
import Modal from 'src/components/Modal';
import { MENSAGEM_ERRO_DEFAULT } from 'src/utils/constants';
import DatePicker from 'vue2-datepicker';
import BarChart from 'src/components/BarChart';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['', ''];
const colunas = ['Ano', 'Mês', 'Geração kWh', 'R$ kWh', 'Observações'];
const colunasLembretes = ['Data', 'Descrição'];
const colunasBoletim = ['Data', 'Descrição', 'Observação'];
export default {
  components: {
    LTable,
    PropostaForm,
    vPagination,
    VTooltip,
    VueTabs,
    VTab,
    DatePicker,
    Modal,
    BarChart
  },
  data() {
    return {
      tabelaLinhaDoTempo: {
        columns: [...tableColumns],
        data: []
      },
      tecnologiaOptions: [
        { value: 'inversor-string', label: 'Inversor String' },
        { value: 'micro-inversor', label: 'Microinversor' },
        { value: 'solar-edge', label: 'SolarEdge' }
      ],
      meses: [
        { value: 'janeiro', label: 'janeiro' },
        { value: 'fevereiro', label: 'fevereiro' },
        { value: 'marco', label: 'março' },
        { value: 'abril', label: 'abril' },
        { value: 'maio', label: 'maio' },
        { value: 'junho', label: 'junho' },
        { value: 'julho', label: 'julho' },
        { value: 'agosto', label: 'agosto' },
        { value: 'setembro', label: 'setembro' },
        { value: 'outubro', label: 'outubro' },
        { value: 'novembro', label: 'novembro' },
        { value: 'dezembro', label: 'dezembro' }
      ],
      geracao: {
        ano: '',
        mes: '',
        geracaoEmKwh: '',
        valorKwh: '',
        obs: ''
      },
      dataTableRelatorioGeracao: {
        columns: [...colunas],
        data: []
      },
      tabelaLembretes: {
        columns: [...colunasLembretes],
        data: []
      },
      tabelaBoletim: {
        columns: [...colunasBoletim],
        data: []
      },
      lembrete: {
        data: '',
        descricao: ''
      },
      boletim: {
        data: '',
        descricao: '',
        obs: ''
      },
      pdfUrl: '',
      cliente: {
        inicioGarantia: '',
        fimGarantia: '',
        usina: {
          inversor: {}
        },
        modulos: [
          {
            potencia: '',
            fabricante: '',
            quantidade: ''
          }
        ],
        inversores: [
          {
            potencia: '',
            fabricante: '',
            quantidade: ''
          }
        ]
      },
      proposta: {},
      isPropostaReady: false,
      mostrarDetalhes: false,
      isModalVisible: false,
      anuncioAction: '',
      anuncio: {},
      isDeleteModalVisible: false,
      anuncioToDelete: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      codigo: '',
      lead: undefined,
      isVisibleModalNovaMensagem: false,
      novaMensagem: '',
      isVisibleModalConverter: false,
      geracoes: {},
      opcoesGraficoGeracoes: {},
      graficoGeracoesStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      }
    };
  },
  created() {},
  beforeCreate() {},
  mounted() {
    this.codigo = this.$router.history.current.params.codigo;
    this.getCliente();
  },
  methods: {
    addModulo() {
      this.cliente.modulos.push({
        potencia: '',
        fabricante: '',
        quantidade: ''
      });
    },
    removeModulo(index) {
      if (this.cliente.modulos.length > 1) {
        this.cliente.modulos.splice(index, 1);
      }
    },
    addInversor() {
      this.cliente.inversores.push({
        potencia: '',
        fabricante: '',
        quantidade: ''
      });
    },
    removeInversor(index) {
      if (this.cliente.inversores.length > 1) {
        this.cliente.inversores.splice(index, 1);
      }
    },
    addGeracaoData() {
      if (
        this.geracao.geracaoEmKwh &&
        this.geracao.valorKwh &&
        this.geracao.mes &&
        this.geracao.ano
      ) {
        this.geracao.economiaMedia =
          this.geracao.geracaoEmKwh * this.geracao.valorKwh;
        this.dataTableRelatorioGeracao.data.push(this.geracao);
        this.geracao = {
          ano: '',
          mes: '',
          geracaoEmKwh: '',
          valorKwh: '',
          obs: '',
          economiaMedia: ''
        };
      } else {
        this.notify({
          message: 'Favor preencher dados de Geração',
          type: 'info'
        });
      }
    },
    formatarDataParaMostrarAoAddFront(dataParaFormatar) {
      return (
        dataParaFormatar.slice(8, 10) +
        '/' +
        dataParaFormatar.slice(5, 7) +
        '/' +
        dataParaFormatar.slice(0, 4)
      );
    },
    formatarDataPadraoBr(dataParaFormatar) {
      return (
        dataParaFormatar.slice(8, 10) +
        '/' +
        dataParaFormatar.slice(5, 7) +
        '/' +
        dataParaFormatar.slice(0, 4)
      );
    },
    formatarDataParaSalvarNoBanco(dataParaFormatar) {
      var dafaFormatada =
        dataParaFormatar.slice(3, 5) +
        '-' +
        dataParaFormatar.slice(0, 2) +
        '-' +
        dataParaFormatar.slice(6, 10);
      return new Date(dafaFormatada);
    },
    deletarLembrete(rowIndex) {
      this.tabelaLembretes.data.splice(rowIndex, 1);
    },
    addLembrete() {
      if (this.lembrete.data && this.lembrete.descricao) {
        this.tabelaLembretes.data.push(this.lembrete);
        this.lembrete = {
          descricao: '',
          data: ''
        };
      } else {
        this.notify({
          message: 'Favor preencher dados de Lembrete',
          type: 'info'
        });
      }
    },
    deletarlembrete(rowIndex) {
      this.dataTableRelatorioGeracao.data.splice(rowIndex, 1);
    },
    addBoletim() {
      if (this.boletim.descricao && this.boletim.obs) {
        this.boletim.pdfUrl = this.pdfUrl;
        this.boletim.data = formatDateFns(new Date(), 'dd/MM/yyyy', {
          locale: ptBR
        });
        //this.boletim.data = new Date().toISOString();
        if (this.boletim.pdfUrl) {
          this.tabelaBoletim.data.push(this.boletim);
          this.boletim = {
            descricao: '',
            data: '',
            obs: '',
            pdfUrl: ''
          };
          this.pdfUrl = '';
        } else {
          delete this.boletim.pdfUrl;
          this.tabelaBoletim.data.push(this.boletim);
          this.boletim = {
            descricao: '',
            data: '',
            obs: ''
          };
        }
      } else {
        this.notify({
          message: 'Favor preencher dados de Boletim',
          type: 'info'
        });
      }
    },
    checkedRadio() {
      if (this.cliente.tipoParceiro === 'pf') {
        return true;
      }
      if (this.cliente.tipoParceiro === 'pj') return false;
    },
    converterDataParaSalvarNoBanco(itens) {
      itens.forEach(item => {
        item.data = this.formatarDataParaSalvarNoBanco(item.data);
      });
      return itens;
    },
    converteDataLembretesPadraoBr(lembretes) {
      lembretes.forEach(lembrete => {
        lembrete.data = this.formatarDataPadraoBr(lembrete.data);
      });
      return lembretes;
    },
    uploadPdf() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.pdfUrl = result.info.url;
          } else {
            this.notify({
              message: 'Erro ao Anexar PDF, favor contatar o suporte.',
              type: 'error'
            });
          }
        }
      );
      myWidget.open();
    },
    salvarCliente() {
      const loader = this.createLoading();
      this.cliente.relatorioDeGeracao = this.dataTableRelatorioGeracao.data;
      this.cliente.lembretes = this.tabelaLembretes.data;
      this.cliente.boletim = this.tabelaBoletim.data;

      var cliente = JSON.parse(JSON.stringify(this.cliente));
      if (this.cliente._id) {
        ClientesService.atualizar(cliente)
          .then(() => {
            this.notify({
              message: 'Cliente atualizado com sucesso',
              type: 'success'
            });

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      } else {
        delete cliente.usina;
        delete cliente.lembretes;
        delete cliente.boletim;
        delete cliente.fimGarantia;
        delete cliente.inicioGarantia;
        delete cliente.relatorioDeGeracao;
        if (cliente.tipoParceiro === 'pj') {
          delete cliente.nome;
          delete cliente.sobrenome;
        } else if (cliente.tipoParceiro === 'pf') {
          delete cliente.razaoSocial;
          delete cliente.pessoaContato;
        }
        ClientesService.salvar(cliente)
          .then(() => {
            this.notify({
              message: 'Cliente Criado com sucesso',
              type: 'success'
            });

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    },

    getCliente() {
      if (this.codigo) {
        const loader = this.createLoading();

        ClientesService.getByCodigo(this.codigo)
          .then(response => {
            var cliente;
            this.lead = response.data;
            cliente = _.get(response, 'data');
            this.cliente = { ...cliente };
            if (cliente.qtdKwp) {
              this.cliente.qtdKwp = cliente.qtdKwp.$numberDecimal;
            }

            this.dataTableRelatorioGeracao.data = cliente.relatorioDeGeracao;
            this.tabelaBoletim.data = cliente.boletim;
            this.tabelaLembretes.data = cliente.lembretes;
            this.proposta.cliente = {
              cidade: cliente.cidade,
              cidadeMediaMensal: cliente.cidadeMediaMensal,
              classe: cliente.classe,
              consumoMedio: cliente.consumoMedio,
              cpfOrCnpj: cliente.cpfOrCnpj,
              email: cliente.email,
              estado: cliente.estado,
              idEmissor: cliente.idEmissor,
              nome: cliente.nome,
              nomeCompleto: cliente.nomeCompleto,
              precoKWH: cliente.precoKWH,
              telefone: cliente.telefone,
              tensao: cliente.tensao,
              tipoParceiro: cliente.tipoParceiro,
              valorMediaMensalCidade: cliente.valorMediaMensalCidade
            };
            this.proposta.codigo = cliente.codigo;
            this.proposta.data = cliente.dataCriacao;
            this.proposta._id = cliente._id;
            this.proposta.emissor = { ...cliente.emissor };
            this.proposta.propostaGerada = { ...cliente.propostaGerada };
            if (cliente.propostaGerada) {
              this.isPropostaReady = true;
            } else {
              this.isPropostaReady = false;
            }
            this.cliente.usina = {};
            this.cliente.usina.modulo = {};
            this.cliente.usina.inversor = {};
            if (this.cliente.inicioGarantia) {
              this.cliente.inicioGarantia = new Date(
                this.cliente.inicioGarantia
              );
            }
            if (this.cliente.fimGarantia) {
              this.cliente.fimGarantia = new Date(this.cliente.fimGarantia);
            }

            this.montarGraficos(cliente.geracoesDiarias[0]);

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    montarGraficos(geracoesDiarias) {
      if (geracoesDiarias.anos.length > 1 || geracoesDiarias.anos[0].kwp > 0) {
        this.geracoes = {
          dias: {
            labels: geracoesDiarias.dias.map(geracao => geracao.dia),
            datasets: [
              {
                label: 'kWh',
                backgroundColor: 'blue',
                data: geracoesDiarias.dias.map(geracao => geracao.kwp)
              }
            ]
          },
          meses: {
            labels: geracoesDiarias.meses.map(geracao => geracao.mes),
            datasets: [
              {
                label: 'kWh',
                backgroundColor: 'blue',
                data: geracoesDiarias.meses.map(geracao => geracao.kwp)
              }
            ]
          },
          anos: {
            labels: geracoesDiarias.anos.map(geracao => `${geracao.ano}`),
            datasets: [
              {
                label: 'kWh',
                backgroundColor: 'blue',
                data: geracoesDiarias.anos.map(geracao => `${geracao.kwp}`)
              }
            ]
          }
        };
        this.opcoesGraficoGeracoes = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true
            },
            x: {
              beginAtZero: true
            }
          }
        };
      }
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    },
    openModalNovaMensagem() {
      this.novaMensagem = '';
      this.isVisibleModalNovaMensagem = true;
    },
    closeModalNovaMensagem() {
      this.isVisibleModalNovaMensagem = false;
    },
    enviarMensagem() {},
    openModalConverter() {
      this.novaMensagem = '';
      this.isVisibleModalConverter = true;
    },
    closeModalConverter() {
      this.isVisibleModalConverter = false;
    },
    converter() {},
    formatarDataPadraoBrByDate(data) {
      return formatDateFns(new Date(data), 'dd/MM/yyyy', {
        locale: ptBR
      });
    },
    enviarRelatorioGeracaoMensal() {
      const loader = this.createLoading();
      ClientesService.enviarRelatorioGeracaoMensal(this.cliente)
        .then(() => {
          this.notify({
            message: 'Relatório de Geração enviado com sucesso.',
            type: 'success'
          });

          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;

          this.notify({
            message,
            type: 'danger'
          });
        });
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.getLead();
      }
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
.crm-tabs .nav {
  display: block !important;
}

.garantias {
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}
</style>
